<template>
  <div>
    <div class="timeslot-weekly-preferences m-1">

      <el-row
       v-for="(pref, idx) in weekday_preferences_sorted"
       :key="'wkr-'+idx"
       class="weekday-pref"
       v-if="showInactiveItems || !pruned_weekday_preferences.includes( pref.$id )">
        <el-col :span="2">

          <a href="#" @click.prevent="onRemoveRow(pref.$id)">
            <font-awesome-icon icon="trash" />
          </a>
          #{{pref.num}}
          <template v-if="SHOW_DEBUG">
            <a class="up-down" href="#" @click.prevent="onSortUpDown('down', pref.$id)" v-if="idx !== weekday_preferences_sorted.length - 1">&#9661;</a>
            <a class="up-down" href="#" @click.prevent="onSortUpDown('up', pref.$id)" v-if="idx !== 0">&#9651;</a>
          </template>
          <span class="list-debug-slug" v-show="SHOW_DEBUG">{{pref.$id.substr(0,7)}}</span>

        </el-col>
        <el-col :span="22" :style="{
          textDecoration:
            pruned_weekday_preferences.includes( pref.$id ) ? 'line-through' : (
              partly_pruned_weekday_preferences.includes( pref.$id ) ? 'line-through dotted var(--azure)' :
                'none' )
            }">

          Plan every

          <div style="display: inline-block; line-height: 1em">
            <WeekdaySelector size="mini" :key="pref.hash" v-model="pref.selectedWeekdays" @save="onSave(pref.$id, 'selectedWeekdays', $event)"></WeekdaySelector>
          </div>

          between

          <TimeSelector
            size="mini"
            v-model="pref.from"
            placeholder="Start time"
            :time-picker-options="getAllowedTimeRange('from', pref)"
            @save="onSave(pref.$id, 'from', $event)"></TimeSelector>

          and

          <TimeSelector
            size="mini"
            v-model="pref.to"
            placeholder="End time"
            :time-picker-options="getAllowedTimeRange('to', pref)"
            @save="onSave(pref.$id, 'to', $event)"></TimeSelector>.

          <div v-if="showActiveRange" style="font-size: 8pt">
            Active between

            <DateSelector
              size="mini"
              v-model="pref.valid_after"
              placeholder="Pick a start day"
              :default-is-today="true"
              text_if_empty="always"
              :disable-before="current_date"
              @save="onSave(pref.$id, 'valid_after', $event)"></DateSelector>

            and

            <DateSelector
              size="mini"
              v-model="pref.valid_before"
              placeholder="Pick a end day"
              text_if_empty="always"
              :default-is-today="true"
              :disable-before="pref.valid_after"
              @save="onSave(pref.$id, 'valid_before', $event)"></DateSelector>.

          </div>

        </el-col>
      </el-row>

      <el-button size="mini" @click.prevent="onClickAddWeekdayPreference" class="mt-1 ml-0">
        <font-awesome-icon icon="plus-circle" size="1x" />
        Add regular timeslot starting {{get_view_range_start.format('l')}}
      </el-button>

      <el-button size="mini" @click.prevent="onPrioritizeWeekdayPreferences" class="mt-1 ml-0">
        Set priorities
      </el-button>

      <!--
      <CollapseGroup title="Actionplanner settings" :initCollapse="true" v-if="!isBlockerTSC">
        <div style="margin-bottom: 0.75em">Select the type of effort you want us to prioritize:</div>
        <el-radio-group
          v-model="prioritizedEffortType"
          @change="onUpdatePrioritizedEffortType"
          size="mini">
          <el-radio label="COMMITMENT_TEMPLATE">Templates</el-radio><br>
          <el-radio label="COMMITMENT">Auto-schedule (Default)</el-radio><br>
          <el-radio label="SEQUENCE_TYPE1">Static Sequence</el-radio><br>
          <el-radio label="SEQUENCE_TYPE2">Dynamic Sequence</el-radio><br>
          <el-radio label="FIXED_TSC">Manual schedule</el-radio>
        </el-radio-group>
      </CollapseGroup>
      -->

    </div>

    <!------------------------ tscPrioritiesModal -------------------------- -->
    <PrioritiesModal ref="tscPrioritiesModal" @save="onSavePriorities">
      <p>You can change the priority of weekly regular timeslots (weekday preferences) here.
        TODO: Explain how this information is used.</p>
    </PrioritiesModal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WeekdaySelector from '@/components/Elements/WeekdaySelectorInline';
import TimeSelector from '@/components/Elements/TimeSelectorInline';
import DateSelector from '@/components/Elements/DateSelectorInline';
import PrioritiesModal from '@/components/CalendarPage/Legacy/Elements/PrioritiesModal'
import moment from '@/moment-gp'

export default {
  props: {
    timeslot_collection_id: {
      type: String,
      default: ""
    },
    isBlockerTSC: {
      type: Boolean,
      default: false
    },
    showActiveRange: {},
    showInactiveItems: {},
  },
  data: () => ({
    // prioritizedEffortType: null
  }),
  mounted() {
    /*
    if ( this.timeslot_collection.prioritizedEffortType ) {
      this.prioritizedEffortType = this.timeslot_collection.prioritizedEffortType;
    } else {
      this.prioritizedEffortType = 'COMMITMENT';
    }
    */
  },
  computed: {
    ...mapGetters('timeslots', [
      'flattened_calendar_data_all',
    ]),
    ...mapGetters('calendar', [
      'get_view_range_start'
    ]),

    current_date() {
      return moment.currentDate();
    },

    weekday_preferences_sorted() {
      // TODO: Can be optimized (first filter, then sort)
      let list = this.$models.timeslotWeekdayPref.getList().itemsSorted
      return list.filter(pref => pref.tscId === this.timeslot_collection_id ).map( pref => pref.clone() )
    },

    /*
    weekday_preferences_sorted() {
      let list =  this.$models.timeslotWeekdayPref
        .with({ timeslotCollectionId: this.timeslot_collection_id })
        .getList()
      return list ? list.itemsAsArray() : []
    },
    */

    pruned_weekday_preferences() {
      let flattened_calendar_data = this.flattened_calendar_data_all[this.timeslot_collection_id];
      return flattened_calendar_data.pruned_weekday_preferences || [];
    },

    partly_pruned_weekday_preferences() {
      let flattened_calendar_data = this.flattened_calendar_data_all[this.timeslot_collection_id];
      return flattened_calendar_data.partly_pruned_weekday_preferences || [];
    },
  },
  methods: {
    onClickAddWeekdayPreference() {
      console.log("onClickAddWeekdayPreference", this.get_view_range_start.format());
      this.$api.timeslot_collection_add_rule({
        timeslotCollectionId: this.timeslot_collection_id,
        rule: {
          sortidx: this.weekday_preferences_sorted.length + 1,
          selectedWeekdays: '--x--x-',
          from: '8:00',
          to: '10:00',
          valid_after: this.get_view_range_start.startOf('day'), // TODO: utc? fromFullCalendarV3? ...No
          valid_before: null,
        }
      })
    },

    onPrioritizeWeekdayPreferences() {
      let weekday_preferences_sortable =
        this.weekday_preferences_sorted.map((pref) => {
          return {
            id:    pref.$id,
            name:  `# ${pref.selectedWeekdays} from ${pref.from} to ${pref.to}`,
            color: 'black'
          };
        });
      console.log("weekday_preferences_sortable", weekday_preferences_sortable);
      this.$refs.tscPrioritiesModal.open(weekday_preferences_sortable);
    },

    onSavePriorities( sorted_list ) {
      console.log("onSavePriorities", sorted_list);

      let sortidx = 1;
      let priorities = sorted_list.map(item => {
        return { id: item.id, sortidx: sortidx++ }
      });

      this.$api.timeslot_collection_set_rule_priorities({
        timeslotCollectionId: this.timeslot_collection_id,
        priorities
      }).then(() => {
        console.log("writing prio done");
      });
    },

    onSortUpDown(direction, ruleId) {
      // console.log("onSortUpDown", direction, index);
      // let new_index = index;
      // switch (direction) {
      //   case 'up':   new_index = index - 1; break;
      //   case 'down': new_index = index + 1; break;
      // }
      // this.weekday_preferences_sorted.move(index, new_index)

      // this.$api.timeslot_collection_update_rule({
      //   timeslotCollectionId: this.timeslot_collection_id,
      //   ruleId: ruleId,
      //   newRule: {
      //     sortidx: -1 // TODO
      //   }
      // })
      throw new Error('Not implemented');
    },

    onRemoveRow( ruleId ) {
      this.$api.timeslot_collection_rem_rule({
        timeslotCollectionId: this.timeslot_collection_id,
        ruleId: ruleId
      })
    },

    /*
    onUpdatePrioritizedEffortType(label) {
      console.log("onUpdatePrioritizedEffortType", label);

      this.$api.timeslot_collection_set_prioritized_effort_type({
        timeslotCollectionId: this.timeslot_collection_id,
        prioritizedEffortType: label
      })
    },
    */

    onSave(prefId, field, event) {
      const updatedRuleValid = {};
      updatedRuleValid[field] = event;

      this.$api.timeslot_collection_update_rule({
        timeslotCollectionId: this.timeslot_collection_id,
        ruleId: prefId,
        newRule: updatedRuleValid
      })
    },

    getAllowedTimeRange(type, pref) {
      // console.log("getAllowedTimeRange", type, pref);
      // TODO: Add 30 minutes
      if ( type === 'from' ) {
        return {
          start: '00:00',
          step:  '00:30',
          end:   pref.to,
        }
      }
      if ( type === 'to' ) {
        return {
          start: pref.from,
          step:  '00:30',
          end:   '24:00'
        }
      }
    }
  },
  components: {
    PrioritiesModal,
    WeekdaySelector,
    TimeSelector,
    DateSelector,
  }
}
</script>

<style>
.timeslot-weekly-preferences {
  /* border: 2px solid red; */
}
.timeslot-weekly-preferences .weekday-pref.el-row {
  margin-bottom: 0.5em;
}
.list-debug-slug {
  line-height: 1em;
  font-size: 8pt;
  color: grey;
  display: block;
}
a.up-down {
  color: black;
}
a.up-down:hover {
  text-decoration: none;
  color: var(--info);
}
</style>
